import {
  parsePhoneNumber,
  isValidPhoneNumber,
  CountryCode,
} from 'libphonenumber-js/min';

export const formatPhoneNumber = (phoneNumber: string): string => {
  try {
    // Remove spaces, dashes, and parentheses for robust parsing
    const cleaned = phoneNumber.replace(/[\s\-()]/g, '');
    const parsed = parsePhoneNumber(cleaned);

    // US formatting
    if (
      (parsed.country === 'US' || cleaned.startsWith('+1')) &&
      parsed.nationalNumber.length === 10
    ) {
      return `+1 (${parsed.nationalNumber.slice(
        0,
        3
      )}) ${parsed.nationalNumber.slice(3, 6)}-${parsed.nationalNumber.slice(
        6
      )}`;
    }

    // International formatting
    const nationalFormat = parsed.formatNational();
    if (!nationalFormat.startsWith('+')) {
      return `+${parsed.countryCallingCode} ${nationalFormat}`;
    }
    return nationalFormat;
  } catch (error) {
    // Fallback: manual US formatting if possible
    const fallback = phoneNumber.replace(/[\s\-()]/g, '');
    if (fallback.startsWith('+1') && fallback.length === 12) {
      return `+1 (${fallback.slice(2, 5)}) ${fallback.slice(
        5,
        8
      )} - ${fallback.slice(8)}`;
    }
    return phoneNumber;
  }
};

export const validatePhoneNumber = (
  phoneNumber: string,
  countryCode: string = 'US'
): boolean => {
  try {
    return isValidPhoneNumber(
      phoneNumber,
      countryCode.toUpperCase() as CountryCode
    );
  } catch {
    return false;
  }
};

export const parsePhoneNumberData = (phoneNumber: string) => {
  try {
    const parsed = parsePhoneNumber(phoneNumber);
    return {
      countryCode: parsed.country,
      nationalNumber: parsed.nationalNumber,
      internationalNumber: parsed.number,
      isValid: true,
    };
  } catch {
    return {
      countryCode: 'US',
      nationalNumber: phoneNumber,
      internationalNumber: phoneNumber,
      isValid: false,
    };
  }
};

export const getPhoneDisplayInfo = (
  phoneNumber: string,
  source: string,
  status: string
) => {
  return {
    formattedNumber: formatPhoneNumber(phoneNumber),
    source,
    status,
    isVerified: status === 'VERIFIED',
    isPending: status === 'CODE_SENT',
    isUnverified: status === 'UNVERIFIED',
  };
};
